var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vSelect',{staticClass:"MunicipalitySelection",attrs:{"disabled":_vm.disabled,"options":_vm.options,"clearable":false,"reduce":option => option.value},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }